<template>
    <div id="clients_edit_page" class="container-fluid">
        <div class="tabs">
            <a href="javascript:void(0)" @click="active_tab = 'basic_info'" :class="{ 'active': active_tab === 'basic_info' }">Basic Info</a> |
            <a href="javascript:void(0)" @click="active_tab = 'metric_glossary'" :class="{ 'active': active_tab === 'metric_glossary' }">Metric Glossary | </a>
            <a href="javascript:void(0)" @click="active_tab = 'ad_library'" :class="{ 'active': active_tab === 'ad_library' }">Ad Library | </a>
            <a href="javascript:void(0)" @click="active_tab = 'ga4_goals'" :class="{ 'active': active_tab === 'ga4_goals' }">GA4 Goals</a>
        </div>

        <hr>

        <div v-if="active_tab === 'basic_info'">
            <form>
                <div class="form-group">
                    <div class="row">
                        <div class="col-xs-12 col-md-6">
                            <label for="client_name">CLIENT NAME</label>
                            <input v-model="client_name" type="text" class="form-control col-xs-12 col-md-10 col-log-8 col-xl-6" id="client_name" autofocus>
                        </div>
                        <div class="col-xs-12 col-md-6">
                            <span class="d-flex flex-column justify-content-center pull_channel_groupings">
                                <span class="text-uppercase title">channel groupings</span>
                                <span v-if="client.pull_channel_groupings > 0" class="text-uppercase">KBK CUSTOM CHANNEL GROUPINGS</span>
                                <span v-else class="text-uppercase">GA4 DEFAULT</span>
                            </span>
                        </div>
                    </div>


                </div>

                <div class="form-group">
                    <label>PROJECT MANAGER</label>
                    <div class="col-md-3 col-lg-2 padding-x0">
                        <v-select v-model="project_manager" :reduce="user => user.id" label="full_name" :options="users"></v-select>
                    </div>
                </div>

                <div class="form-group">
                    <div class="row padding-x10">
                        <div class="col-xs-4">
                            <div class="report-image">
                                <img v-if="report_image_loaded" :src="report_image_loaded" height="65">
                            </div>
                        </div>

                        <div class="col-xs-6 margin-left20">
                            <label>UPLOAD REPORT IMAGE</label>
                            <div>
                                <input @change="reportImageChanged" id="report_image" type="file" class="form-control hidden" name="report_image" accept="image/x-png,image/gif,image/jpeg">
                            </div>

                            <span class="input-wrap text-left">
                                <button type="button" id="file-browse" class="btn btn-info reverse" @click="browse">Browse</button>
                            </span>
                        </div>
                    </div>
                </div>

                <div class="form-group margin-top20">
                    <h5 class="margin-bottom10">Currently connected accounts ({{ client_data_connection_accounts.count }})</h5>

                    <table class="table table-borderless data-connection-accounts">
                        <tbody>
                            <template v-for="data_connection_accounts in client_data_connection_accounts.data">
                                <template v-for="data_connection_account in data_connection_accounts">
                                    <tr>
                                        <td class="align-middle">
                                            <img :src="`${$store.state.app_url}images/data_sources/${data_connection_account.abbreviation}.png`">
                                            <span>{{ data_connection_account.name }}</span>
                                        </td>
                                        <td class="align-middle">
                                            <span>{{ data_connection_account.name_given_by_user }}</span>
                                        </td>
                                        <td class="align-middle">
                                            <span>{{ data_connection_account.primary_name_in_source }} ({{ data_connection_account.primary_account_id }})</span>
                                        </td>
                                        <td class="align-middle text-right">
                                            <button @click="disconnect(data_connection_account.id)" type="button" class="btn btn-danger reverse">Disconnect</button>
                                        </td>
                                    </tr>
                                </template>
                            </template>
                        </tbody>
                    </table>
                </div>

                <div v-if="all_data_connection_accounts" class="form-group">
                    <div class="padding-bottom30">
                        <h5 class="pull-left margin-bottom0">Choose which accounts to use from your data connections</h5>

                        <div class="pull-right">
                            <input @input="filterDataConnectionAccounts" type="text" placeholder="Search accounts..." class="form-control search-accounts">
                        </div>
                    </div>

                    <div id="select_accounts">
                        <div v-for="(data_connection_accounts, data_source_name) in all_data_connection_accounts" class="card">
                            <div class="card-header" :id="`data_connection_accounts_${data_connection_accounts[0].abbreviation}`">
                                <div class="row">
                                    <div class="col-4">
                                        <img class="d-inline-block" :src="`${$store.state.app_url}images/data_sources/${data_connection_accounts[0].abbreviation}.png`">
                                        <h5 class="mb-0 mt-1 d-inline-block">{{ data_source_name }}</h5>
                                    </div>
                                    <div class="col-4">
                                        <h5 class="mt-1">Profiles ({{ data_connection_accounts.length }})</h5>
                                    </div>
                                    <div class="col-4">
                                        <button
                                            type="button"
                                            class="btn btn-info reverse pull-right"
                                            data-toggle="collapse"
                                            :data-target="`#collapse_${data_connection_accounts[0].abbreviation}`"
                                            aria-expanded="true"
                                            :aria-controls="`collapse_${data_connection_accounts[0].abbreviation}`">
                                            View
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <div :id="`collapse_${data_connection_accounts[0].abbreviation}`" class="collapse" :aria-labelledby="`data_connection_accounts_${data_connection_accounts[0].abbreviation}`" data-parent="#select_accounts">
                                <div class="card-body padding-y0">
                                    <v-client-table :data="data_connection_accounts" :columns="select_accounts_columns" :options="select_accounts_options">
                                        <button @click="connectOrDisconnect(props.row.id)" slot="actions" slot-scope="props" type="button" class="btn reverse pull-right" :class="selected_accounts.indexOf(props.row.id) > -1 ? 'btn-danger' : 'btn-info'">
                                            {{ selected_accounts.indexOf(props.row.id) > -1 ? 'Disconnect' : 'Connect' }}
                                        </button>
                                    </v-client-table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else class="form-group">
                    <div class="padding-bottom30">
                        <h5 class="pull-left margin-bottom0">You still have no data sources connected. Click <small><a href="../data_sources">here</a></small> to make a connection.</h5>
                    </div>
                </div>
                <div class="form-group">
                    <h5 class="margin-bottom10">User access</h5>

                    <div class="col-12 margin-bottom10">
                        <label><p-input id="check_all_users" class="p-switch p-slim users-all" @change="selectAllUsers" type="checkbox" :checked="all_users_checked"> Select all</p-input></label>
                    </div>

                    <div class="col-10 col-xl-6" id="users_table_wrap">
                        <template v-if="ai_admin_users.length">
                            <label>AI Admin</label>
                            <div class="row">
                                <template v-for="user in users">
                                    <div v-if="ai_admin_users.includes(user.id)" class="col-4 mb-3">
                                        <label><p-input type="checkbox" v-model="selected_users" class="p-default p-curve single" name="selected_users[]" :value="user.id" @change="checkAll"> {{ user.full_name }}</p-input></label>
                                    </div>
                                </template>
                            </div>
                        </template>
                        <template v-if="super_admin_users.length">
                            <label>Super Admin</label>
                            <div class="row">
                                <template v-for="user in users">
                                    <div v-if="super_admin_users.includes(user.id)" class="col-4 mb-3">
                                        <label><p-input type="checkbox" v-model="selected_users" class="p-default p-curve single" name="selected_users[]" :value="user.id" @change="checkAll"> {{ user.full_name }}</p-input></label>
                                    </div>
                                </template>
                            </div>
                        </template>
                        <template v-if="admin_users.length">
                            <label>Admin</label>
                            <div class="row">
                                <template v-for="user in users">
                                    <div v-if="admin_users.includes(user.id)" class="col-4 mb-3">
                                        <label><p-input type="checkbox" v-model="selected_users" class="p-default p-curve single" name="selected_users[]" :value="user.id" @change="checkAll"> {{ user.full_name }}</p-input></label>
                                    </div>
                                </template>
                            </div>
                        </template>
                        <template v-if="client_user_users.length">
                            <label>Client User</label>
                            <div class="row">
                                <template v-for="user in users">
                                    <div v-if="client_user_users.includes(user.id)" class="col-4 mb-3">
                                        <label><p-input type="checkbox" v-model="selected_users" class="p-default p-curve single" name="selected_users[]" :value="user.id" @change="checkAll"> {{ user.full_name }}</p-input></label>
                                    </div>
                                </template>
                            </div>
                        </template>
                    </div>
                </div>

                <div class="form-group text-center">
                    <button :disabled="!validateClient" id="save_client"
                            data-loading-text='<span class="spinner-border spinner-border-sm margin-right5" role="status" aria-hidden="true"></span>Saving...'
                            @click="saveClient" type="button" class="btn btn-info btn-lg"
                            style="pointer-events:initial !important;">SAVE CHANGES</button>
                </div>
            </form>
        </div>

        <div id="metric_glossary" v-if="active_tab === 'metric_glossary'">
            <div id="rename_metric" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">Metric renaming</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <form>
                                <div class="form-group">
                                    <label for="client_name">METRIC NAME</label>
                                    <input v-model="new_metric_name" type="text" class="form-control" id="client_name" autofocus>
                                </div>

                                <div v-if="metric_renaming_data_sources.length > 0" class="form-group">
                                    <label class="margin-bottom10" for="client_name">DATA SOURCES</label>
                                    <div class="row">
                                        <label class="col-xl-4" v-for="ds in metric_renaming_data_sources"><input v-model="metric_renaming_selected_data_sources" type="checkbox" :value="ds.data_source_id"> {{ ds.name }}</label>
                                    </div>
                                </div>
                                <template v-if="is_goal_metric && /smart\s*goal/i.test(new_metric_name)">
                                    <label>Start Date:</label>
                                    <date-picker v-model="smart_goal_start_date" value-type="format" format="YYYY-MM-DD" type="date" placeholder="Start date"></date-picker>
                                </template>
                            </form>
                        </div>

                        <div class="modal-footer">
                            <button type="button" class="btn" data-dismiss="modal">Cancel</button>
                            <template v-if="is_goal_metric && /smart\s*goal/i.test(new_metric_name)">
                                <button :disabled="!smart_goal_start_date || !new_metric_name || (metric_renaming_data_sources.length > 0 && metric_renaming_selected_data_sources.length === 0)" type="button" class="btn btn-success" @click="saveNewMetricName">Save</button>
                            </template>
                            <template v-else>
                                <button :disabled="!new_metric_name || (metric_renaming_data_sources.length > 0 && metric_renaming_selected_data_sources.length === 0)" type="button" class="btn btn-success" @click="saveNewMetricName">Save</button>
                            </template>

                        </div>
                    </div>
                </div>
            </div>

            <v-client-table :data="metric_glossary_data" :columns="metric_glossary_columns" :options="metric_glossary_options">
                <div slot="new_metric_name" slot-scope="props">
                    <span>{{ props.row.new_metric_name || '---' }}</span>
                    <span @click="renameMetric(props.row)" class="margin-left15 edit-icon"><i class="fa fa-pencil" aria-hidden="true"></i></span>
                    <span v-if="props.row.new_metric_name" @click="resetMetricName(props.row)" class="margin-left5 delete-icon"><i class="fa fa-times" aria-hidden="true"></i></span>
                </div>

                <div slot="data_sources" slot-scope="props">
                    <img class="ds-icon" v-for="data_source_abbr in props.row.data_sources.split(',')" :src="$store.state.app_url + '/images/data_sources/' + data_source_abbr + '.png'">
                </div>
            </v-client-table>
        </div>

        <div id="ad_library" v-if="active_tab === 'ad_library'">
            <div id="add_edit_ad" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true">
                <div class="modal-dialog modal-xl" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">{{ ad_edit_id ? 'Update Ad' : 'Add New Ad' }}</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <form>
                                <div class="row">
                                    <div class="col-4">
                                        <div class="row">
                                            <div class="col-12">
                                                <div class="preview-ad-image">
                                                    <img :src="`${$store.state.app_url}images/no_image.png`" class="w-100">
                                                </div>
                                            </div>

                                            <div class="col-12 margin-top20">
                                                <div class="input-group">
                                                    <div class="custom-file">
                                                        <input @change="browseAd" id="ad_image_file" type="file" class="custom-file-input">
                                                        <label class="custom-file-label" for="ad_image_file">Choose Ad Image</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-8">
                                        <div class="row">
                                            <div class="form-group col-8">
                                                <label for="add_edit_ad_name">NAME<span class="text-danger">*</span></label>
                                                <input v-model="add_edit_ad_name" id="add_edit_ad_name" type="text" class="form-control">
                                            </div>

                                            <div class="form-group col-8">
                                                <label for="add_edit_ad_comment">COMMENT</label>
                                                <input v-model="add_edit_ad_comment" id="add_edit_ad_comment" type="text" class="form-control">
                                            </div>

                                            <div class="col-12">
                                                <div class="row">
                                                    <div class="form-group col-4">
                                                        <label for="add_edit_ad_comment">START DATE</label>
                                                        <date-picker :disabled-date="adStartDate" v-model="add_edit_ad_start_date" value-type="format" popup-class="ad-library-datepicker" format="YYYY-MM-DD" type="date" placeholder="Start date"></date-picker>
                                                    </div>

                                                    <div class="form-group col-4">
                                                        <label for="add_edit_ad_comment">END DATE</label>
                                                        <date-picker :disabled-date="adEndDate" v-model="add_edit_ad_end_date" value-type="format" popup-class="ad-library-datepicker" format="YYYY-MM-DD" type="date" placeholder="End date"></date-picker>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="col-12">
                                                <div class="row">
                                                    <div class="form-group col-4">
                                                        <label>AD TYPE</label>
                                                        <v-select :disabled="add_edit_ad_new_type.length > 0" :clearable="false" v-model="add_edit_ad_ad_type" label="type" :options="add_edit_ad_ad_types"></v-select>
                                                    </div>

                                                    <div class="form-group col-4">
                                                        <label for="ad_new_type">OR ENTER NEW TYPE</label>
                                                        <input v-model="add_edit_ad_new_type" id="ad_new_type" type="text" class="form-control">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn" data-dismiss="modal">Cancel</button>
                            <button type="button" class="btn btn-success" @click="saveAd">Save</button>
                        </div>
                    </div>
                </div>
            </div>

            <div>
                <button @click="newAd" type="button" class="btn btn-secondary main-button pull-right">+ Add New Ad</button>
            </div>

            <v-client-table :data="ad_library_data" :columns="ad_library_columns" :options="ad_library_options">
                <div slot="image" slot-scope="props">
                    <a class="thumbnail" href="#thumb">
                        <img :src="`data:${props.row.image_mime_type};base64,${props.row.image_data}`" class="thumb">
                        <span><img :src="`data:${props.row.image_mime_type};base64,${props.row.image_data}`"></span>
                    </a>
                </div>

                <div slot="actions" slot-scope="props" class="text-right">
                    <button @click="editAd(props.row.id)" class="btn btn-info reverse">Edit</button>
                    <button @click="removeAd(props.row.id)" class="btn btn-danger reverse btn-icon">
                        <i class="fa fa-trash-o" aria-hidden="true"></i>
                    </button>
                </div>
            </v-client-table>
        </div>
        <div id="ga4_goals" v-if="active_tab === 'ga4_goals'">
            <v-client-table :data="ga4_goals_data" :columns="ga4_goals_columns" :options="ga4_goals_options">

            </v-client-table>
            <div class="form-group">
                <span class="event-metric"><label>Event metric:</label><v-select v-model="event_metric" label="event_metric" :options="event_metrics"></v-select></span>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        created() {
            this.fetchServerData();
        },
        updated() {
            this.validateForm();
        },
        mounted() {
            $(document).off('hide.bs.collapse', '#select_accounts').on('hide.bs.collapse', '#select_accounts', function(event) {
                $(event.target).prev().find('button').text('View');
            }).off('show.bs.collapse', '#select_accounts').on('show.bs.collapse', '#select_accounts', function(event) {
                $(event.target).prev().find('button').text('Hide');
            });
        },

        data() {
            return {
                active_tab:                      'basic_info',
                original_form_data:              {},
                client:                          '',
                event_metrics:                   ['conversions', 'event_count'],
                client_name:                     '',
                selected_currency:               3, // Hardcoded to USD for now
                project_manager:                 '',
                event_metric:                    null,
                currencies:                      [],
                report_image_loaded:             '',
                report_image:                    '',
                search_accounts_timeout:         null,
                all_data_connection_accounts:    null,
                selected_accounts:               [],
                users:                           [],
                selected_users:                  [],
                client_data_connection_accounts: [],
                all_users_checked:               false,
                ai_admin_users:                  [],
                super_admin_users:               [],
                admin_users:                     [],
                client_user_users:               [],
                save_changes_button_disabled:    true,
                submitted:                       false,

                select_accounts_columns: ['name_given_by_user', 'account_full_name', 'actions'],
                select_accounts_options: {
                    headings: {
                        name_given_by_user: '',
                        account_full_name:  '',
                        actions:            ''
                    },
                    sortable: [],

                    perPage: 10,
                    perPageValues: [],
                    texts: {
                        count: '',
                        filter: '',
                        filterPlaceholder: 'Search accounts...',
                        noResults: ''
                    },
                    skin: 'table table-borderless'
                },

                metric_glossary_data: [],
                metric_glossary_columns: ['original_metric_name', 'new_metric_name', 'data_sources'],
                metric_glossary_options: {
                    headings: {
                        original_metric_name: 'Original Metric Name',
                        new_metric_name:      'New Metric Name',
                        data_sources:         'Data Source'
                    },
                    sortable: ['original_metric_name', 'new_metric_name'],

                    perPage: 20,
                    perPageValues: [],
                    texts: {
                        count: 'Showing {from} to {to} of {count} metrics|{count} metrics|One metric',
                        filter: '',
                        filterPlaceholder: 'Search metrics...',
                        noResults: 'No matching metrics'
                    },
                    skin: 'table'
                },

                ga4_goals_data: [],
                ga4_goals_columns: ['event_name', 'report_name'],
                ga4_goals_options: {
                    headings: {
                        event_name: 'Event Name',
                        report_name:'Name in Interface'
                    },
                    sortable: ['event_name', 'report_name'],

                    perPage: 20,
                    perPageValues: [],
                    texts: {
                        count: 'Showing {from} to {to} of {count} events |{count} events|One event',
                        filter: '',
                        filterPlaceholder: 'Search events...',
                        noResults: 'No matching events'
                    },
                    skin: 'table'
                },

                is_goal_metric:                        false,
                smart_goal_start_date:                      '',
                new_metric_name:                       '',
                metric_renaming_metric_id:             '',
                metric_renaming_data_sources:          [],
                metric_renaming_selected_data_sources: [],

                ad_library_data: [],
                ad_library_columns: ['image', 'name', 'type', 'start_date', 'end_date', 'uploader', 'actions'],
                ad_library_options: {
                    headings: {
                        image:      '',
                        name:       'Name',
                        type:       'Type',
                        start_date: 'Start Date',
                        end_date:   'End Date',
                        uploader:   'Uploader',
                        actions:    ''
                    },
                    sortable: ['name', 'type', 'start_date', 'end_date', 'uploader'],

                    perPage: 10,
                    perPageValues: [],
                    texts: {
                        count: 'Showing {from} to {to} of {count} ads|{count} ads|One ad',
                        filter: '',
                        filterPlaceholder: 'Search ads...',
                        noResults: 'No matching ads'
                    },
                    skin: 'table'
                },

                add_edit_ad_image:      '',
                add_edit_ad_name:       '',
                add_edit_ad_comment:    '',
                add_edit_ad_start_date: '',
                add_edit_ad_end_date:   '',
                add_edit_ad_ad_type:    'None',
                add_edit_ad_new_type:   '',
                add_edit_ad_ad_types:   [],
                ad_edit_id:             null
            }
        },

        methods: {
            fetchServerData() {
                axios.all([
                    axios.get(`/api/clients/${this.$route.params.id}`),
                    axios.get('/api/currencies'),
                    axios.get('/api/data-connections'),
                    axios.get(`/api/data-connections/clients/${this.$route.params.id}`),
                    axios.get(`/api/clients/${this.$route.params.id}/permissions`),
                    axios.get('/api/users'),
                    axios.get(`/api/metrics/client/${this.$route.params.id}/glossary`),
                    axios.get(`/api/ad-library?client_id=${this.$route.params.id}`),
                    axios.get('/api/ad-library/types'),
                    axios.get(`/api/events/client/${this.$route.params.id}/ga4_events`),
                ])
                .then(axios.spread((client, currencies, dataConnectionAccounts, clientDataConnectionAccounts, permissions, users, glossary, adLibrary, adTypes, ga4_events) => {
                    this.client                          = client.data;
                    this.client_name                     = client.data.name;
                    this.selected_currency               = client.data.currency_id || '';
                    this.project_manager                 = client.data.project_manager_id || '';
                    this.event_metric                    = client.data.event_metric || 'conversions';
                    this.report_image_loaded             = client.data.report_image ? 'https://f000.backblazeb2.com/file/kbpark/' + client.data.report_image : '';
                    this.currencies                      = currencies.data;
                    this.all_data_connection_accounts    = dataConnectionAccounts.data;
                    this.client_data_connection_accounts = clientDataConnectionAccounts.data;
                    this.selected_users                  = permissions.data;
                    this.users                           = users.data;
                    this.metric_glossary_data            = glossary.data;
                    this.ad_library_data                 = adLibrary.data;
                    this.add_edit_ad_ad_types            = adTypes.data;
                    this.ga4_goals_data                  = ga4_events.data;
                    this.all_users_checked               = this.users.length > 0 && (this.selected_users.length == this.users.length);

                    if (clientDataConnectionAccounts.data.count > 0) {
                        _.each(clientDataConnectionAccounts.data.data, accounts => {
                            _.each(accounts, account => {
                                this.selected_accounts.push(account.id);
                            });
                        });
                    }

                    _.each(this.users, user => {
                        user.checked = 0;
                        if(this.selected_users.includes(user.id)){
                            user.checked = 1;
                        }
                        if(user.short_name == 'ai_admin'){
                            this.ai_admin_users.push(user.id);
                        }
                        if(user.short_name == 'super_admin'){
                            this.super_admin_users.push(user.id);
                        }
                        if(user.short_name == 'admin'){
                            this.admin_users.push(user.id);
                        }
                        if(user.short_name == 'client_user'){
                            this.client_user_users.push(user.id);
                        }
                    });

                    this.saveOriginalFormData(client, users);
                }));
            },
            browse() {
                $('#report_image').click();
            },

            reportImageChanged(event) {
                const vue = this;
                let files = event.currentTarget.files;

                if (files && files[0]) {
                    var reader = new FileReader;

                    reader.onload = function(e) {
                        vue.report_image_loaded = e.target.result;
                    }

                    reader.readAsDataURL(files[0]);

                    this.report_image = files[0];
                }
            },

            disconnect(accountId) {
                _.each(this.client_data_connection_accounts.data, dataConnectionAccounts => {
                    let index = _.findIndex(dataConnectionAccounts, {id: accountId});

                    if (index > -1) {
                        dataConnectionAccounts.splice(index, 1);
                    }
                });

                this.connectOrDisconnect(accountId);
            },

            connectOrDisconnect(accountId) {
                const index = this.selected_accounts.indexOf(accountId);

                if (index === -1) {
                    this.selected_accounts.push(accountId);
                } else {
                    this.selected_accounts.splice(index, 1);
                }

                this.validateForm();
            },

            selectAllUsers(event) {
                this.all_users_checked = event;
                this.selected_users = [];
                if (event) {
                    _.each(this.users, user => {
                        this.selected_users.push(user.id);
                    });
                }
            },
            checkAll(event){
                if($('.single > input').length == $('.single > input:checked').length){
                    $('.users-all > input').prop('checked', true);
                }
                else{
                    $('.users-all > input').prop('checked', false);
                }
            },
            filterDataConnectionAccounts(event) {
                if (this.search_accounts_timeout) {
                    clearTimeout(this.search_accounts_timeout);
                    this.search_accounts_timeout = null;
                }

                this.search_accounts_timeout = setTimeout(() => {
                    axios.get(`/api/data-connections?search_term=${event.target.value.trim()}`).then(response => {
                        this.all_data_connection_accounts = response.data;
                    });
                }, 500);
            },

            saveClient() {
                if(this.submitted == true) return;
                this.submitted = true;
                $('#save_client').button('loading');

                let formData = new FormData;
                formData.append('client_name', this.client_name);
                formData.append('selected_currency', this.selected_currency || '');
                formData.append('project_manager', this.project_manager || '');
                formData.append('report_image', this.report_image || '');
                formData.append('selected_accounts', this.selected_accounts.length ? JSON.stringify(this.selected_accounts) : '');
                formData.append('selected_users', this.selected_users.length ? JSON.stringify(this.selected_users) : '');
                formData.append('_method', 'PUT');

                this.ajaxSubmit({'Content-Type': 'multipart/form-data'}, 'POST', `/api/clients/${this.$route.params.id}`, formData).then(response => {
                    $('#save_client').button('reset');

                    this.$notify({
                        type: 'success',
                        text: this.messages.CLIENT_UPDATED
                    });
                    this.submitted = false;
                    this.$router.push({path: '/clients'});
                });
            },
            saveEventMetric() {
                let formData = new FormData;
                formData.append('event_metric', this.event_metric || 'conversions');
                formData.append('_method', 'POST');

                this.ajaxSubmit({'Content-Type': 'multipart/form-data'}, 'POST', `/api/clients/event_metric/${this.$route.params.id}`, formData).then(response => {

                });
            },

            renameMetric(row) {
                this.is_goal_metric                        = /goal*/i.test(row.original_metric_name);
                this.new_metric_name                       = row.new_metric_name || '';
                this.metric_renaming_data_sources          = [];
                this.metric_renaming_selected_data_sources = [];
                this.client_x_metric_x_data_source_id      = '';
                this.metric_renaming_metric_id             = row.metric_id;

                if(!!row.smart_goal_start_date){
                    this.smart_goal_start_date = row.smart_goal_start_date;
                }

                if (row.new_metric_name && row.client_x_metric_x_data_source_id) {
                    $('#rename_metric').modal('show');

                    this.client_x_metric_x_data_source_id = row.client_x_metric_x_data_source_id;
                } else {
                    const queryString = $.param({
                        data_source_ids: row.data_source_ids.split(',')
                    });

                    axios.get(`/api/data_sources?${queryString}`).then(response => {
                        this.metric_renaming_data_sources = response.data;

                        $('#rename_metric').modal('show');
                    });
                }
            },

            saveNewMetricName() {
                let formData = new FormData;
                formData.append('metric_id', this.metric_renaming_metric_id);
                formData.append('new_metric_name', this.new_metric_name);
                formData.append('data_source_ids', this.metric_renaming_selected_data_sources.length > 0 ? JSON.stringify(this.metric_renaming_selected_data_sources) : '');
                formData.append('client_x_metric_x_data_source_id', this.client_x_metric_x_data_source_id);
                if(this.smart_goal_start_date){
                    formData.append('smart_goal_start_date', this.smart_goal_start_date);
                }
                formData.append('_method', 'PUT');

                $('#rename_metric').modal('hide');

                this.ajaxSubmit({}, 'POST', `/api/metrics/client/${this.$route.params.id}/glossary`, formData).then(response => {
                    this.$notify({
                        type: 'success',
                        text: 'Metric name has been successfully updated.'
                    });

                    this.updateMetricGlossary();
                });
            },

            resetMetricName(row) {
                this.confirmation('Are you sure you want to restore original metric name?', () => {
                    axios.delete(`/api/metrics/client/${this.$route.params.id}/glossary?metric_x_data_source_id=${row.metric_x_data_source_id}`).then(response => {
                        this.$notify({
                            type: 'success',
                            text: 'Metric name has been successfully restored.'
                        });

                        this.updateMetricGlossary();
                    });
                });
            },

            updateMetricGlossary() {
                axios.get(`/api/metrics/client/${this.$route.params.id}/glossary`).then(response => {
                    this.metric_glossary_data = response.data;
                });
            },

            browseAd(event) {
                $(event.target).siblings('.custom-file-label').addClass('selected').html($(event.target).val().split("\\").pop());

                if (event.target.files && event.target.files[0]) {
                    const reader = new FileReader;

                    reader.onload = function(e) {
                        $('#add_edit_ad').find('.preview-ad-image img').attr('src', e.target.result);
                    }

                    reader.readAsDataURL(event.target.files[0]);

                    this.add_edit_ad_image = event.target.files[0];
                }
            },

            newAd() {
                this.add_edit_ad_image      = '';
                this.add_edit_ad_name       = '';
                this.add_edit_ad_comment    = '';
                this.add_edit_ad_start_date = '';
                this.add_edit_ad_end_date   = '';
                this.add_edit_ad_ad_type    = 'None';
                this.add_edit_ad_new_type   = '';
                this.ad_edit_id             = null;

                $('#add_edit_ad').find('.preview-ad-image img').attr('src', `${this.$store.state.app_url}images/no_image.png`);
                $('#add_edit_ad').find('.custom-file-label').removeClass('selected').text('Choose Ad Image');
                $('#add_edit_ad').modal('show');

                axios.get('/api/ad-library/types').then(response => {
                    this.add_edit_ad_ad_types = response.data;
                });
            },

            editAd(id) {
                axios.get(`/api/ad-library/${id}`).then(response => {
                    const file   = this.dataURLtoFile(`data:${response.data.image_mime_type};base64,${response.data.image_data}`, response.data.image_name);
                    const reader = new FileReader;

                    reader.onload = function(e) {
                        $('#add_edit_ad').find('.preview-ad-image img').attr('src', e.target.result);
                    }

                    reader.readAsDataURL(file);

                    this.add_edit_ad_image      = file;
                    this.add_edit_ad_name       = response.data.name;
                    this.add_edit_ad_comment    = response.data.comment;
                    this.add_edit_ad_start_date = response.data.start_date;
                    this.add_edit_ad_end_date   = response.data.end_date;
                    this.add_edit_ad_ad_type    = response.data.type;
                    this.add_edit_ad_new_type   = '';
                    this.ad_edit_id             = id;

                    $('#add_edit_ad').find('.custom-file-label').addClass('selected').text(response.data.image_name);
                    $('#add_edit_ad').modal('show');

                    axios.get('/api/ad-library/types').then(response => {
                        this.add_edit_ad_ad_types = response.data;
                    });
                });
            },

            removeAd(id) {
                this.confirmation('Are you sure you want to delete this ad?', () => {
                    axios.delete(`/api/ad-library/${id}`).then(() => {
                        this.$notify({
                            type: 'success',
                            text: 'Ad has been successfully deleted.'
                        });

                        this.refreshAdsTable();
                    });
                });
            },

            saveAd() {
                let formData = new FormData;
                formData.append('client_id', this.$route.params.id);
                formData.append('image', this.add_edit_ad_image);
                formData.append('name', this.add_edit_ad_name);
                formData.append('comment', this.add_edit_ad_comment || '');
                formData.append('start_date', this.add_edit_ad_start_date || '');
                formData.append('end_date', this.add_edit_ad_end_date || '');
                formData.append('ad_type', this.add_edit_ad_new_type || this.add_edit_ad_ad_type);

                let url = '/api/ad-library';

                if (this.ad_edit_id) {
                    url += `/${this.ad_edit_id}`;
                    formData.append('_method', 'PUT');
                }

                this.ajaxSubmit({'Content-Type': 'multipart/form-data'}, 'POST', url, formData).then(response => {
                    $('#add_edit_ad').modal('hide');

                    this.$notify({
                        type: 'success',
                        text: `Ad has been successfully ${this.ad_edit_id ? 'updated' : 'saved'}.`
                    });

                    this.refreshAdsTable();
                });
            },

            adStartDate(date) {
                if (this.add_edit_ad_end_date) {
                    return date > new Date(this.add_edit_ad_end_date).setHours(0, 0, 0, 0);
                }
            },

            adEndDate(date) {
                if (this.add_edit_ad_start_date) {
                    return date < new Date(this.add_edit_ad_start_date).setHours(0, 0, 0, 0);
                }
            },

            refreshAdsTable() {
                axios.get(`/api/ad-library?client_id=${this.$route.params.id}`).then(response => {
                    this.ad_library_data = response.data;
                });
            },

            saveOriginalFormData(client, users) {
                this.original_form_data.users               = vm.customClone(users.data);
                this.original_form_data.client_name         = client.data.name;
                this.original_form_data.project_manager     = client.data.project_manager_id;
                this.original_form_data.event_metric        = client.data.event_metric;
                this.original_form_data.report_image_loaded = this.report_image_loaded;
                this.original_form_data.selected_accounts   = vm.customClone(this.selected_accounts);
            },

            validateForm() {
                let disabled = true;
                if ((this.submitted == false) && (
                    (this.original_form_data.client_name != this.client_name)
                    || (this.original_form_data.project_manager != this.project_manager)
                    || (this.original_form_data.event_metric != this.event_metric)
                    || (this.original_form_data.report_image_loaded != this.report_image_loaded)
                    || (JSON.stringify(this.original_form_data.selected_accounts) != JSON.stringify(this.selected_accounts))
                )) {
                    disabled = false;
                }

                const currentSelectedUsers = document.querySelectorAll('#users_table_wrap input');

                if (currentSelectedUsers.length) {
                    _.each(this.original_form_data.users, function(user, i) {
                        if (!!user.checked !== currentSelectedUsers[i].checked) {
                            disabled = false;
                        }
                    });
                }

                this.save_changes_button_disabled = disabled;
            }
        },

        computed: {
            validateClient() {
                return !!(!this.save_changes_button_disabled && !this.submitted);
            }
        },

        watch: {
            selected_users() {
                $('#check_all_users').prop('checked', this.users.length === this.selected_users.length);
            },
            event_metric(newVal, oldVal){
                if(newVal && oldVal && newVal != oldVal){
                    this.saveEventMetric();
                }
            }
        }
    }
</script>

<style lang="scss">
    @import '~@/_variables.scss';

    #clients_edit_page {
        .tabs {
            a {
                color: #333333;
                font-weight: 500;
                text-decoration: none;

                &.active {
                    color: #36a8cd;
                }
            }
        }

        #metric_glossary {
            .VueTables__table {
                table-layout: fixed;
            }

            .edit-icon {
                border-radius: 100%;
                padding: 6px;
                box-shadow: 0px 0px 3px #71d2fd;
                color: #049bdd;
                cursor: pointer;
            }

            .delete-icon {
                border-radius: 100%;
                padding: 6px;
                box-shadow: 0px 0px 3px #ffa3a3;
                color: #d80000;
                cursor: pointer;
            }

            .ds-icon {
                width: 3rem;
            }
        }

        #ad_library {
            .thumbnail {
                position: relative;
                z-index: 0;
            }

            .thumbnail:hover {
                background-color: transparent;
                z-index: 50;
            }

            .thumbnail span {
                position: absolute;
                background-color: white;
                padding: .5rem;
                left: -100rem;
                box-shadow: 0 0 .3rem #aaa;
                visibility: hidden;
                color: black;
                text-decoration: none;
            }

            .thumbnail span img {
                border-width: 0;
                padding: .2rem;
                width: 40rem;
                height: 40rem;
                object-fit: contain;
            }

            .thumbnail:hover span {
                visibility: visible;
                top: 0;
                left: 7.2rem;
            }

            .v-select.vs--disabled {
                opacity: .6;
            }

            .preview-ad-image {
                max-width: 34.7rem;
                max-height: 36.6rem;

                img {
                    height: 36rem;
                    object-fit: contain;
                }
            }

            .mx-datepicker {
                width: 100%;
            }

            .VueTables__table {
                overflow: visible !important;
            }

            .table-responsive {
                overflow: visible !important;

                img.thumb {
                    width: 7rem;
                    height: 7rem;
                    object-fit: contain;
                }

                .fa-trash-o {
                    font-size: 1.6rem;
                }
            }
        }

        .form-group {
            margin-bottom: 2.4rem;
        }

        .data-connection-accounts {
            font-size: 1.44rem;

            td:first-child {
                font-weight: 500;
            }

            img {
                width: 3.2rem;
            }
        }

        .search-accounts {
            width: 20vw;
        }

        #select_accounts {
            clear: both;

            tr, td {
                outline: none!important;
            }

            table {
                table-layout: fixed;
                font-size: 1.44rem;

                thead {
                    display: none;
                }

                td {
                    vertical-align: middle;
                }
            }

            .VueTables__search {
                display: none;
            }

            .VuePagination {
                padding-bottom: 1rem;
            }

            img {
                width: 3.2rem;
            }
        }

        .card {
            margin-top: -0.4rem;
            border: none;
        }

        .report-image {
            background: #f1f1f1;
            width: 6.4rem;
            height: 6.4rem;
            overflow: hidden;
        }
        button:disabled{
            cursor:not-allowed;
            &:hover{
                color:white;
            }
        }
        .pretty.p-default input:checked ~ .state label::after {
            background-color:$secondary !important;
        }
        .pretty.p-switch input:checked ~ .state label::after {
            background-color:$secondary !important;
        }
        .pretty{
            line-height:1 !important;
        }

        span.event-metric{
            label{
                font-weight: bold;
            }
            div.v-select{
                display:inline-block;
                min-width:150px;
                margin-left:20px;
            }
        }
    }
    span.pull_channel_groupings{
        font-size:1.2rem;
        & > span.title{
            font-weight:bold;
            margin-bottom:1rem
        }
    }
</style>
